<template>
  <div>
    <!-- Header -->
    <Navbar />

    <!-- Page Content -->
    <div class="app-container">
      <router-view />
      <search-bot v-if="$route.path !== '/search-bot'" />
    </div>
  </div>
</template>

<script setup>
import SearchBot from '@/views/search-bot/index.vue'
import Navbar from './Navbar.vue'
</script>
<style scoped>
.app-container {
  margin-top: 76px;
}
</style>